import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BadgeCheck, Download } from "lucide-react";
import { createStoredCertificatePdfBlob } from "../components/Certificate";
import { validarCertificado } from "../services/certificadoService";
import { formatCertificateDate } from "../utils/certificado";

// Pagina publica do link compartilhado: nao usa Header/sessao, pois e aberta por pessoas de fora.
const CertificadoValidacao = () => {
  const { codigo } = useParams();
  const [certificate, setCertificate] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    let objectUrl;
    setLoading(true);
    setError("");

    const load = async () => {
      try {
        // Busca os dados pelo codigo publico e recria o PDF no navegador.
        const saved = await validarCertificado(codigo);
        if (!active) return;
        const blob = await createStoredCertificatePdfBlob(saved);
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setCertificate(saved);
        setPdfUrl(objectUrl);
      } catch (err) {
        if (active) setError("Certificado não encontrado. Confira se o link está completo.");
      } finally {
        if (active) setLoading(false);
      }
    };
    load();
    // Libera a memoria do PDF ao sair da pagina.
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [codigo]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#FAF9F7] px-4 py-12 text-zinc-900 dark:bg-zinc-950 dark:text-zinc-100">
      <div className="w-full max-w-xl rounded-2xl border border-zinc-200 bg-white p-6 shadow-sm dark:border-zinc-800 dark:bg-zinc-900 sm:p-8">
        <p className="mb-6 text-center text-sm font-semibold uppercase tracking-wide text-[#B95758] dark:text-rose-300">Foods Academy</p>
        {loading ? (
          <p role="status" className="text-center">Validando certificado...</p>
        ) : error ? (
          <p role="alert" className="text-center text-red-700 dark:text-red-300">{error}</p>
        ) : certificate && (
          <>
            <div className="mb-6 flex flex-col items-center text-center">
              <BadgeCheck className="mb-3 h-12 w-12 text-emerald-600 dark:text-emerald-400" aria-hidden="true" />
              <h1 className="text-xl font-bold sm:text-2xl">Certificado válido</h1>
              <p className="mt-2 text-zinc-600 dark:text-zinc-400">Este certificado foi emitido pela Foods Academy.</p>
            </div>
            <dl className="grid gap-4 text-sm sm:grid-cols-2">
              <div className="sm:col-span-2"><dt className="text-zinc-500 dark:text-zinc-400">Participante</dt><dd className="mt-1 break-words font-semibold">{certificate.nome_completo}</dd></div>
              <div className="sm:col-span-2"><dt className="text-zinc-500 dark:text-zinc-400">Curso</dt><dd className="mt-1 break-words font-semibold">{certificate.nome_curso}</dd></div>
              <div><dt className="text-zinc-500 dark:text-zinc-400">Conclusão</dt><dd className="mt-1 font-semibold"><time dateTime={certificate.data_conclusao}>{formatCertificateDate(certificate.data_conclusao)}</time></dd></div>
              <div><dt className="text-zinc-500 dark:text-zinc-400">CNPJ</dt><dd className="mt-1 font-semibold">{certificate.cnpj}</dd></div>
              <div className="sm:col-span-2"><dt className="text-zinc-500 dark:text-zinc-400">Empresa emissora</dt><dd className="mt-1 break-words font-semibold">{certificate.company_name}</dd></div>
            </dl>
            <a href={pdfUrl} download="certificado.pdf" className="mt-8 flex items-center justify-center gap-2 rounded-lg bg-[#B95758] px-5 py-3 font-semibold text-white hover:bg-[#9f3f40]">
              <Download className="h-5 w-5" aria-hidden="true" /> Baixar PDF
            </a>
          </>
        )}
      </div>
    </main>
  );
};

export default CertificadoValidacao;
